import React from "react";

export const ApertureDivider = ({ className = "" }) => (
  <div className={`aperture-divider mx-auto my-2 ${className}`} aria-hidden>
    <span className="line mag" />
    <span className="ring" />
    <span className="line cy" />
  </div>
);

export default ApertureDivider;
